import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import PageAuth from "@components/views/Auth/PageAuth";

const SignIn = ({ afterSignInPath }) => (
  <PageAuth
    initType="signin"
    afterSignInPath={afterSignInPath}
  />
);

export async function getServerSideProps({ params: { locale }, query }) {
  const afterSignInPath = query.redirect || false;

  return {
    props: {
      afterSignInPath,
      headerBehaviors: { auth: true },
      ...(await getMessagesForNamespaces(locale, ["common", "accounts"])),
    },
  };
}

SignIn.requireNoAuth = true;

export default SignIn;
